const PAYMENT_TYPES = [
  { text: 'Virtual Account', value: 'virtual_account' },
  { text: 'Bank Transfer', value: 'bank_transfer' },
  { text: 'Cheque', value: 'cheque' },
  { text: 'Cash', value: 'cash' },
  { text: 'Credit Card', value: 'credit_card' },
  { text: 'MHub Pay', value: 'online_payment' },
  { text: 'Others', value: 'others' },
];

export default PAYMENT_TYPES;



// WEBPACK FOOTER //
// ./src/constants/paymentTypes.js